import { Authorizations } from "~/api/types";
import { canCollectionMember } from "~/helpers/authorizations";

import { Site } from "../../api/Api";
import { SiteCard, Stats } from "./SiteCard";
import styles from "./SiteList.module.scss";

type SiteWithStats = Site & {
  stats: Stats;
};
interface SiteListProps {
  sites: SiteWithStats[];
  sitesIsPenging: boolean;
  authorizations?: Authorizations;
}

export const SiteList = ({
  sites,
  sitesIsPenging,
  authorizations,
}: SiteListProps) => {
  return (
    <section className={styles.siteList} aria-label="Site list">
      {sites?.length > 0
        ? sites?.map((site, idx) => {
            const canDelete = canCollectionMember(
              authorizations,
              idx,
              "destroy",
            );

            return (
              <SiteCard
                key={site.id}
                site={site}
                sitesIsPenging={sitesIsPenging}
                canDelete={canDelete}
              />
            );
          })
        : Array(10)
            .fill(null)
            .map((_, index) => (
              <SiteCard
                key={index}
                site={null}
                sitesIsPenging={sitesIsPenging}
              />
            ))}
    </section>
  );
};
